import styled from 'styled-components';

import colors from '@utils/colors';
import fonts, { weights } from '@utils/fonts';
import { mq } from '@utils/responsive';
import { H_PADDING_MOBILE } from '@utils/space';
import UnstyledLink from '@components/Link';
import { Body as UnstyledBody } from '@components/type';

export const Wrapper = styled.div`
  background-image: url(data:image/svg+xml;base64,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);
  background-size: 600px;
  background-repeat: no-repeat;
  background-position: calc(50% + 150px) 10px;
  padding-top: 160px;
  margin-top: -24px;

  ${mq.gtsm`
      background-size: 800px;
      background-position: calc(50% + 100px) 0;
      padding-top: 180px;
      margin-top: -40px;
  `}

  ${mq.gtmd`
      background-size: 900px;
      background-position: calc(50% + 300px) 0;
      padding-top: 100px;
      margin-top: -20px;
  `}
`;

export const Footer = styled.footer`
  font-family: ${props => fonts(props.theme.locale).SANS};
  padding: 0 ${H_PADDING_MOBILE};

  ${mq.gtsm`
    max-width: 1060px;
    margin: 0 auto;
  `}
`;

export const Body = styled.div`
  margin-bottom: 1rem;

  ${mq.gtmd`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-bottom: 3rem;
  `}
`;

export const Chat = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0 16px;

  ${mq.gtsm`
    margin: 48px 0 32px;
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ChatLink = styled.a`
  display: inline-block;
  margin-top: 8px;
  color: ${colors.B500};
  font-family: ${props => fonts(props.theme.locale).SANS};
  font-size: 14px;
  font-weight: ${weights.BOLD};
  text-decoration: underline;
  cursor: pointer;

  ${mq.gtsm`
    margin-top: 16px;
    font-size: 16px;
  `}
`;

export const Description = styled.div`
  margin-bottom: 2rem;

  ${mq.gtmd`
    width: 45%;
  `}
`;

export const About = styled(UnstyledBody)`
  margin-top: 1rem;
  color: ${colors.N500};
`;

export const Nav = styled.div`
  width: 100%;
  text-align: left;

  ${mq.gtmd`
    width: 50%;
    margin-left: auto;
    text-align: right;
  `}

  ${mq.gtlg`
    width: 50%;
    margin-left: auto;
  `}
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 64px;
  height: 64px;

  &:only-child {
    width: 72px;
    height: 72px;
  }

  ${mq.gtsm`
    width: 96px;
    height: 96px;

    &:only-child {
      width: 120px;
      height: 120px;
    }
  `}
`;

export const ImagesWrapper = styled.div`
  display: flex;
  margin-right: 32px;

  & > *:not(:first-child) {
    margin-top: 32px;
    margin-left: -32px;
  }
`;

export const LinkList = styled.div`
  display: grid;
  gap: 0 30px;
  grid-template-columns: repeat(2, 1fr);
  flex-wrap: wrap;
  margin-bottom: 2rem;
  font-size: 1rem;
  font-weight: ${weights.BOLD};
  margin-top: .8rem;

  ${mq.gtsm`
    font-size: 1.275rem;
  `}
`;

export const Link = styled(UnstyledLink)`
  color: ${colors.N500};

  &:hover {
    color: ${colors.N900};
  }
`;

export const LogoWrapper = styled.div`
  width: 100%;
  flex: 1 0 100%;
  display: flex;
  align-items: center;
  gap: 40px;
`;

export const SocialList = styled.div`
  display: flex;
`;

export const WavyBorder = styled.div`
  margin-bottom: 1rem;

  svg {
    width: 100%;
    height: auto;
  }

  ${mq.gtmd`
    margin-bottom: 2rem;
  `}
`;

export const Enquire = styled.div`
  a {
    z-index: 9999;
    position: fixed;
    background: ${(props) => getEnquireBackground(props.colorTheme)};
    opacity: 0.8;
    bottom: 0;
    width: 100vw;
    left: 0;
    text-align: center;
    height: 64px;


    ${mq.btmlmd`
        right: 30px !important;
    `}

    ${mq.gtmd`
      margin-bottom: 1rem;
      bottom: 30px;
      height: 128px;
      width: 128px;
      border-radius: 50%;
      left: inherit;
      right: calc(50% - 620px);
    `}

    p {
      line-height: 64px;
      margin: 0;
      color: ${colors.N0};
      // letter-spacing: 3px;

      ${mq.gtmd`
        line-height: 128px;
      `}
    }
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  padding-bottom: 24px;
  font-size: 0.75rem;
  color: ${colors.N500};

  ${mq.gtmd`
    align-items: center;
    flex-direction: row;
    padding-bottom: 64px;
    font-size: 0.875rem;
  `}
`;

export const FooterNav = styled.ul`
  display: flex;
  margin-bottom: 1rem;
`;

export const FooterNavItem = styled.li`
  display: flex;

  &:not(:last-child) {
    margin-right: 2rem;
  }

  a {
    color: ${colors.N500};

    &:hover {
      color: ${colors.N900};
    }
  }

  ${mq.gtsm`
  `}
`;

function getEnquireBackground(colorTheme) {
  switch (colorTheme) {
    case 'yellow':
      return colors.Y500;
    case 'green':
      return colors.G500;
    case 'orange':
      return colors.O500;
    case 'purple':
      return colors.P500;
    default:
      return colors.B500;
  }
}
